var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "award-item h-100"
  }, [_c('div', {
    staticClass: "award-logo bg-white"
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.src
    }
  })], 1), _c('div', {
    staticClass: "award-detail pa-20 pa-md-30 pt-70 pt-md-80 pt-lg-110 pb-lg-40 bg-white text-center helvetica"
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold line-height-1 mb-2 mb-lg-4",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(_vm._s(_vm.year))]), _c('p', {
    staticClass: "page-text--sm mb-8 mb-lg-16",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.tit))]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-point line-height-1"
  }, [_vm._v(_vm._s(_vm.sc))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }